import {all, call, put, select} from "typed-redux-saga";
import {ContentPredictorApi} from "apps/BUDWEISERPOTM/modules/utils";
import {
	addVoteAction,
	addVoteActionSuccess,
	addVoteActionFailed,
	addVotesActionSuccess,
	setConfirmModalState,
	saveLocalVotes,
	checkLocalVotes,
} from "apps/BUDWEISERPOTM/modules/actions/votes";
import {getIsUserLogged} from "modules/selectors";
import Storage from "modules/utils/Storage";
import {globalError, openPromoBanner} from "modules/actions";
import {getVoteByMatchId} from "apps/BUDWEISERPOTM/modules/selectors/votes";
import {getLiveVoteGames} from "apps/BUDWEISERPOTM/modules/selectors";
import {isArray} from "lodash";

const VOTE_STORAGE_KEY = "vote";

export const addVoteSaga = function* (action: ReturnType<typeof addVoteAction>) {
	try {
		const isLogged = yield* select(getIsUserLogged);
		const voteSelector = yield* select(getVoteByMatchId);
		const prediction = voteSelector(action.payload.gameId);
		let result;

		if (prediction?.id) {
			result = yield* call(ContentPredictorApi.Votes.patchVotes, {
				voteId: prediction.id,
				playerId: action.payload.playerId,
			});
		} else {
			result = yield* call(ContentPredictorApi.Votes.postVotes, action.payload);
		}

		if (!isLogged) {
			const storedVotes = Storage.GET(VOTE_STORAGE_KEY) || "[]";
			const votes = JSON.parse(storedVotes) as
				| ReturnType<typeof addVoteAction>["payload"][]
				| ReturnType<typeof addVoteAction>["payload"];

			const votesArray = isArray(votes)
				? [...votes, action.payload]
				: [votes, action.payload];
			Storage.SET(VOTE_STORAGE_KEY, votesArray);
		}
		yield* put(addVoteActionSuccess(result.success));

		yield* put(setConfirmModalState(action.payload));
		yield* put(openPromoBanner());
	} catch (err) {
		const {message} = err as Error;
		yield* put(addVoteActionFailed(message));
		yield* put(globalError(message));
	}
};

export const getVotesSaga = function* () {
	try {
		const isLogged = yield* select(getIsUserLogged);

		if (isLogged) {
			const result = yield* call(ContentPredictorApi.Votes.getVotes);
			yield* put(addVotesActionSuccess(result.success));
			yield* put(saveLocalVotes());
		} else {
			yield* put(checkLocalVotes());
		}
	} catch (err) {
		const {message} = err as Error;
		yield* put(addVoteActionFailed(message));
		yield* put(globalError(message));
	}
};

export const saveLocalVotesSaga = function* () {
	try {
		const games = yield* select(getLiveVoteGames);

		const storedVotes = Storage.GET(VOTE_STORAGE_KEY) || "[]";
		const votes = JSON.parse(storedVotes) as ReturnType<typeof addVoteAction>["payload"][];
		const arrayVotes = isArray(votes) ? votes : [votes];
		const votesToSave = arrayVotes.filter((vote) => {
			return games.find((game) => game.id === vote.gameId);
		});

		console.log(votesToSave);

		if (votesToSave.length) {
			yield* all(votesToSave.map((vote) => call(ContentPredictorApi.Votes.postVotes, vote)));
			yield* all(votesToSave.map((vote) => put(addVoteActionSuccess(vote))));
			Storage.REMOVE(VOTE_STORAGE_KEY);
		}
	} catch (err) {
		console.log(err);
		Storage.REMOVE(VOTE_STORAGE_KEY);
	}
};

export const checkLocalVotesSaga = function* () {
	try {
		const storedVotes = Storage.GET(VOTE_STORAGE_KEY) || "[]";
		const votes = JSON.parse(storedVotes) as ReturnType<typeof addVoteAction>["payload"][];
		const arrayVotes = isArray(votes) ? votes : [votes];
		console.log(arrayVotes);

		if (arrayVotes.length) {
			yield* all(arrayVotes.map((vote) => put(addVoteActionSuccess(vote))));
		}
	} catch (err) {
		console.log(err);
	}
};
